document.addEventListener("DOMContentLoaded", function () {
    function hideCartCTAIfBot() {
        const botInput = document.querySelector("#bot_trap2");
        const target = document.querySelector(".cart-drawer-subtotal__cta");

        if (!target) return; // Target not found yet

        // Agar session me flag already hai → directly hide
        if (sessionStorage.getItem("botTrap2Triggered") === "true") {
            target.style.display = "none";
            return;
        }

        if (!botInput) return; // Bot input not found yet

        const hasValue = botInput.value && botInput.value.trim() !== "";

        if (hasValue) {
            // Session flag set karo
            sessionStorage.setItem("botTrap2Triggered", "true");
            target.style.display = "none";
            console.log("🚫 bot_trap2 filled → cart-drawer-subtotal__cta permanently hidden (session)");
        } else {
            target.style.display = ""; // Only show if session not triggered
        }
    }

    // Observe DOM changes so late-loaded elements also get checked
    new MutationObserver(hideCartCTAIfBot)
        .observe(document.body, { childList: true, subtree: true });

    // Check when #bot_trap2 changes
    document.addEventListener("input", (e) => {
        if (e.target && e.target.id === "bot_trap2") {
            hideCartCTAIfBot();
        }
    });

    // Safety fallback
    setInterval(hideCartCTAIfBot, 500);
});
